import { graphqlQuery } from './_graphqlQuery';

const mutation = `
mutation timelogCreate($timeSpent: String!, $summary: String!, $issuableId: IssuableID!) {
  timelogCreate(
    input: {timeSpent: $timeSpent, summary: $summary, issuableId: $issuableId}
  ) {
    timelog {
      id
    }
  }
}
`;

interface TrackTimeGql {
  timelogCreate: {
    timelog: {
      id: string;
    };
  };
}

export const trackTime = async (params: {
  timeSpent: string;
  summary: string;
  issuableId: string;
}): Promise<boolean> => {
  const { timeSpent, summary, issuableId } = params;
  await graphqlQuery<TrackTimeGql>(mutation, { timeSpent, summary, issuableId });
  return true;
};
